var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"distribution-container"},[_c('div',{staticClass:"card-list-wrapper"},[_c('news-detail',{attrs:{"is-edit":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }